import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export function RecentTransactions({ transactions }) {
  const fmt = (a) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(a || 0);
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-';

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] mb-4">Recent Transactions</h3>
      {(!transactions || transactions.length === 0) ? (
        <p className="text-sm text-gray-400 text-center py-8">No transactions yet</p>
      ) : (
        <div className="space-y-3">
          {transactions.map((tx, i) => (
            <TxRow key={i} tx={tx} fmt={fmt} fmtDate={fmtDate} />
          ))}
        </div>
      )}
    </div>
  );
}

function TxRow({ tx, fmt, fmtDate }) {
  const isIncome = tx.type === 'income';
  return (
    <div className="flex items-center gap-3 py-2 border-b border-gray-50 last:border-0">
      <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${isIncome ? 'bg-green-50' : 'bg-red-50'}`}>
        {isIncome ? <ArrowUpRight className="w-4 h-4 text-green-600" /> : <ArrowDownRight className="w-4 h-4 text-red-500" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-[#0A1628] truncate">{tx.description}</p>
        <p className="text-xs text-gray-400">{fmtDate(tx.date)} {tx.recurring ? '(recurring)' : ''}</p>
      </div>
      <p className={`font-semibold text-sm ${isIncome ? 'text-green-600' : 'text-red-500'}`}>
        {isIncome ? '+' : '-'}{fmt(tx.amount)}
      </p>
    </div>
  );
}
